const HistoryTab = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          paddingTop: 20,
        }}
      >
        <h1>History</h1>
      </div>
    );
  };
  
  export default HistoryTab;
  